import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MenuCard from "../../Component/MenuCard";
import TittleAndBreadCrumb from "../../Section/TittleAndBreadCrumb";
import { getMenuLevel2 } from "../../services/menuList";
import { UserContext } from "../../UserContext";

/** A sidebar section (e.g. DATA FEEDING): one tile per page in it. */
const MenuLevel1 = () => {
  const { operatorCode } = useContext(UserContext);
  const [result, setResult] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const section = decodeURIComponent(location.pathname.substring(1).split("/")[0]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const items = await getMenuLevel2(
          sessionStorage.getItem("appName"),
          section,
          operatorCode
        );
        setResult(Array.isArray(items) ? items : []);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  return (
    <>
      <TittleAndBreadCrumb />
      <section className="section">
        <div className="row g-3">
          {result.map((item, index) => (
            <MenuCard
              key={index}
              menuItem={item.col2}
              onClick={() => navigate(`/${section}/${item.col2}`)}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default MenuLevel1;
